import SVRMediaRow from './SVRMediaRow';

export default SVRMediaRow;
